export default "__VITE_ASSET__0c7b9bbf__"